<template>
  <div class="account-box">
    <a-tabs v-model="activeKey" @change="tabChange">
      <a-tab-pane tab="未核销" key="0"></a-tab-pane>
      <a-tab-pane tab="已核销" key="1"></a-tab-pane>
    </a-tabs>
    <data-table ref="dataTable" :option="option">
      <template slot="action" slot-scope="text, record">
        <a-button type="link" size="small" @click="edit(text)">查看</a-button>
        <a-popconfirm
          title="确认反核销吗?"
          @confirm="onRevoke(text)"
          okText="确认"
          cancelText="取消"
          v-if="record.Status == 1"
        >
          <a-button type="link" size="small">反核销</a-button>
        </a-popconfirm>
      </template>
    </data-table>

    <a-modal
      centered
      title="核销记录"
      v-model="visible.writeOffModal"
      @ok="AccountingEntry"
      @cancel="visible.writeOffModal = false"
      okText="入账"
      width="80%"
      :afterClose="reload"
      :maskClosable="false"
      :destroyOnClose="true"
      :okButtonProps="{ props: { disabled: isDisabled } }"
      :cancelButtonProps="{ props: { disabled: isOnAccount } }"
      :footer="null"
    >
      <WriteOffRecord
        :logkeys="editId"
        :guestId="Idkey"
        :orderNo="orderNo"
        ref="writeOffRecord"
        @selectRow="writeOffSelect"
        @AccountState="onAccountState"
      />
      <div style="padding: 10px;text-align: right;">
        <a-button
          type="primary"
          style="margin-left:20px;"
          @click="onAccount"
          :disabled="isOnAccount"
          >转账至客户</a-button
        >
        <a-button
          type="primary"
          style="margin-left:20px;"
          @click="AccountingEntry"
          :disabled="isDisabled"
          >入账</a-button
        >
      </div>
    </a-modal>
    <OrderDetail ref="restaurantOrderDetail" :operation="false"></OrderDetail>
  </div>
</template>
<script>
import { DataTable } from "@/components/dataTable";
import { AccountingEntryModal } from "../orderManage/funtion.js";
import WriteOffRecord from "./WriteOffRecord.vue";
import { OnAccountModal } from "./funtion.js";
import {
  OrderDetailModal,
  TeamOrderDetailModal
} from "@/views/orderManage/funtion.js";
import OrderDetail from "@/views/restaurant/OrderDetail";
import moment from "moment";
export default {
  props: {
    Idkey: {
      type: String,
      default: ""
    },
    orderNo: {
      type: [String, Number],
      default: ""
    }
  },
  components: {
    DataTable,
    WriteOffRecord,
    OrderDetail
  },
  data() {
    return {
      visible: {
        writeOffModal: false
      },
      rowId: "",
      editId: "",
      isDisabled: false,
      isOnAccount: true,
      isCost: true,
      option: {},
      data: [],
      activeKey: "0",
      params: { PageSize: 50, CustomerId: this.Idkey, Status: "0" },
      columns: [
        // {
        //   title: "序号",
        //   width: "70px",
        //   align: "center",
        //   type: "indexcolumn"
        // },
        {
          title: "单号",
          width: 100,
          dataIndex: "OrderNo", //列字段名
          customRender: (text, record) => {
            if (text) {
              const orderDetail = {
                click: e => {
                  e.stopPropagation();
                  if (record.OrderCategory == 1) {
                    //餐饮订单
                    this.$refs.restaurantOrderDetail.show(record.OrderId);
                  } else {
                    this.orderDetail(record);
                  }
                }
              };
              return (
                <a-button type="link" {...{ on: orderDetail }} size="small">
                  {text}
                </a-button>
              );
            } else {
              return "";
            }
          }
        },
        {
          title: "挂账日期",
          width: 100,
          dataIndex: "AccountDate"
        },
        {
          title: "状态",
          width: 80,
          dataIndex: "Status",
          customRender: text => {
            if (text) {
              return <a-badge status="success" text="已核销" />;
            } else {
              return <a-badge status="error" text="未核销" />;
            }
          }
        },
        {
          title: "姓名",
          width: 100,
          dataIndex: "Contact"
        },
        {
          title: "住店日期",
          width: 100,
          dataIndex: "CheckInDate"
        },
        {
          title: "离店日期",
          width: 100,
          dataIndex: "CheckOutDate"
        },
        {
          title: "金额",
          width: 100,
          align: "right",
          dataIndex: "Amount"
        },
        {
          title: "核销金额",
          width: 100,
          align: "right",
          dataIndex: "WriteOffAmount"
        },
        {
          title: "未核金额",
          width: 100,
          align: "right",
          dataIndex: "UnWriteOffAmount"
        },
        {
          title: "渠道订单号",
          width: 150,
          dataIndex: "ChannelOrderNo"
        },
        {
          title: "备注",
          tooltip: true,
          dataIndex: "Remark"
        },
        {
          title: "操作",
          dataIndex: "Id",
          width: 140,
          fixed: "right",
          scopedSlots: { customRender: "action" }
        }
      ],
      defaultItem: {},
      checkedRows: []
    };
  },
  created() {
    this.option = {
      headSearch: {
        colnum: 6,
        content: [
          {
            label: "订单号",
            name: "OrderNo"
          },
          {
            label: "住店日期",
            type: "date-range-picker",
            name: "StartRange",
            colnum: 2
          },
          {
            label: "离店日期",
            type: "date-range-picker",
            name: "EndRange",
            colnum: 2
          },
          {
            label: "姓名",
            name: "Contact"
          }
        ],
        onSubmitBefore: values => {
          let json = {
            Contact: values.Contact,
            OrderNo: values.OrderNo,
            Status: this.activeKey
          };
          if (values.StartRange && values.StartRange.length) {
            json.CheckInDateBegin =
              values.StartRange[0] &&
              moment(values.StartRange[0]).format("YYYY-MM-DD");
            json.CheckInDateEnd =
              values.StartRange[1] &&
              moment(values.StartRange[1]).format("YYYY-MM-DD");
          }
          if (values.EndRange && values.EndRange.length) {
            json.CheckOutDateBegin =
              values.EndRange[0] &&
              moment(values.EndRange[0]).format("YYYY-MM-DD");
            json.CheckOutDateEnd =
              values.EndRange[1] &&
              moment(values.EndRange[1]).format("YYYY-MM-DD");
          }
          return json;
        }
      },
      grid: {
        api: "RecVa_GetRePageList",
        params: this.params,
        columns: this.columns,
        rowSelect: true,
        pageChange: json => {
          const data = { ...json };
          data.Status = this.activeKey;
          const ids = (this.checkedRows || []).map(v => v.Id);
          this.$nextTick(() => {
            this.$refs.dataTable.getDataGrid().setSelecteds(ids);
          });

          return data;
        },
        props: {
          scroll: {
            y: "calc(100vh - 260px)",
            x: 1500
          }
        },
        selectedCheckboxRows: (record, selected) => {
          if (selected && !this.checkedRows.find(el => el.Id == record.Id)) {
            this.checkedRows.push(record);
          } else if (!selected) {
            this.checkedRows = this.checkedRows.filter(
              el => el.Id != record.Id
            );
          }
          this.$emit("getCheckedRows", this.checkedRows);
        },
        selectAllCheckboxRows: (selected, selectedRows, changeRows) => {
          const changeIds = (changeRows || []).map(v => v.Id);
          if (selected) {
            changeRows.forEach(el => {
              if (!this.checkedRows.find(item => item.Id == el.Id)) {
                this.checkedRows.push(el);
              }
            });
          } else {
            this.checkedRows = this.checkedRows.filter(
              el => !changeIds.includes(el.Id)
            );
          }
          this.$emit("getCheckedRows", this.checkedRows);
        },
        onLoad: res => {
          this.$emit("loadData", res.Data.Datas);
        }
      }
    };
    this.$post("Room_GetDefaultTime", {}).then(res => {
      res.Data.SystemConstList.forEach(item => {
        this.defaultItem[item.Code] = item.Value;
      });
    });
  },
  methods: {
    orderDetail(record) {
      let that = this;
      if (record.OrderId && record.OrderId != "0") {
        let isOtherDbQuery = false;
        if (that.defaultItem.PlusHotelOrderModel == 1) {
          that
            .$post("TeamOrder_GetDetail", {
              Id: record.OrderId,
              handleError: false
            })
            .then(res => {
              if (res.Message == "查无此单") {
                isOtherDbQuery = true;
              }
              TeamOrderDetailModal({
                orderId: record.OrderId,
                isOtherDbQuery,
                showBtn: !isOtherDbQuery,
                update: () => {
                  // that.search();
                  that.$refs.dataTable.getDataGrid().reload(that.params);
                  that.$nextTick(() => {
                    const ids = (that.checkedRows || []).map(v => v.Id);
                    that.$refs.dataTable.getDataGrid().setSelecteds(ids);
                  });
                }
              });
            });
        } else {
          that
            .$post("Order_Detail", {
              Id: record.OrderId,
              handleError: false
            })
            .then(res => {
              if (res.Message == "查无此单") {
                isOtherDbQuery = true;
              }
              OrderDetailModal({
                orderId: record.OrderId,
                isOtherDbQuery,
                showBtn: !isOtherDbQuery,
                update: () => {
                  // that.search();
                  that.$refs.dataTable.getDataGrid().reload(that.params);
                  that.$nextTick(() => {
                    const ids = (that.checkedRows || []).map(v => v.Id);
                    that.$refs.dataTable.getDataGrid().setSelecteds(ids);
                  });
                }
              });
            });
        }
      }
    },
    tabChange(key) {
      this.activeKey = key;
      this.$refs.dataTable.getRef("headSearchForm").resetFields();
      this.$emit("getUnWriteOffAmount", 0);
      this.params = {
        CustomerId: this.Idkey,
        Status: key
      };
      // let isDisabled = false;
      if (key == "1") {
        this.isDisabled = true;
        this.isOnAccount = false;
      } else {
        this.isDisabled = false;
        this.isOnAccount = true;
      }
      this.$refs.dataTable.getDataGrid().reload(this.params);
      this.checkedRows = [];
      this.$emit("getCheckedRows", this.checkedRows);
      this.$emit("disabledWriteOff", this.isDisabled, this.isOnAccount); //告诉父组件，是否禁用
    },
    edit(id) {
      this.editId = id;
      this.visible.writeOffModal = true;
      this.$post("RecVa_ReDetail", { Id: id }).then(res => {
        if (res.Data.WriteOffRecords == "") {
          this.isOnAccount = false;
        } else {
          this.isOnAccount = true;
        }
      });
    },
    /**
     * @description: 反核销
     * @param {*} id
     * @return {*}
     */

    onRevoke(id) {
      this.$post("RecVa_AdjustWriteOffStatus", { Id: id }).then(() => {
        this.$refs.dataTable.getDataGrid().reload(this.params);
      });
    },
    //入账
    AccountingEntry() {
      let json = {
        ReceivableId: this.editId,
        showRoom: false,
        update: () => {
          this.$refs.writeOffRecord.reload();
        }
      };
      AccountingEntryModal(json);
    },
    reload() {
      this.$refs.dataTable.getDataGrid().reload(this.params);
      this.checkedRows = [];
      this.$emit("getCheckedRows", []);
    },
    //获取当前选中行
    getSelecteds() {
      let rows = this.$refs.dataTable.getSelecteds();
      return rows;
    },
    //获取当前选中行
    getSelected() {
      let row = this.$refs.dataTable.getSelected();
      return row;
    },
    writeOffSelect(selectId) {
      this.rowId = selectId;
    },
    onAccount() {
      OnAccountModal({
        ReceivableId: this.editId,
        update: () => {
          this.visible.writeOffModal = false;
          this.$refs.dataTable.getDataGrid().reload(this.params);
        }
      });
    },
    onAccountState(accountState) {
      this.isCost = accountState;
    }
  }
};
</script>
<style lang="less" scoped>
.account-box {
  /deep/.ant-tabs-nav .ant-tabs-tab {
    padding: 5px 16px 12px;
  }
  /deep/
    .ant-table-small
    > .ant-table-content
    > .ant-table-scroll
    > .ant-table-header
    > table
    > .ant-table-thead
    > tr
    > th,
  /deep/ .ant-table-bordered .ant-table-tbody > tr > td,
  /deep/.ant-table-small
    > .ant-table-content
    > .ant-table-fixed-right
    > .ant-table-header
    > table
    > .ant-table-thead
    > tr
    > th {
    padding: 2px 3px 0 3px !important;
  }
}
.custom-modal .ant-modal-content .ant-modal-close-x {
  height: 36px !important;
  line-height: 36px !important;
}
.custom-modal {
  background: #f00;
}
</style>
